import React from "react";
import { Modal, ModalBody, Spinner } from "reactstrap";
import Text from "components/Text";
import crossIcon from "assets/images/cross.svg";
import { withTranslation } from "react-i18next";
import { useChangeSubscriptionPlanBetweenOfflineToOnline } from "repositories/subscription-repository";
import toast from "react-hot-toast";

function ChangePaymentMethodModal({
  t,
  isOpen,
  closeStepOneModal,
  switchOnOff,
  setSwitchOnOff,
  accountOwnerId,
}) {
  const { mutateAsync, isLoading } =
    useChangeSubscriptionPlanBetweenOfflineToOnline();
  const isLoadingFalse = !isLoading;
  const submitRequest = async () => {
    try {
      await mutateAsync({
        accountOwnerId,
        IsOfflinePaymentAllowed: switchOnOff,
      });
      setSwitchOnOff(!switchOnOff);
      toast.success(
        t(
          `superAdminVendorSubscription.changeSubscriptionUpdateSuccessfullyTo${
            switchOnOff ? "CreditCard" : "Offline"
          }`
        )
      );
      closeStepOneModal(false);
    } catch (e) {
      toast.error(e.message);
    }
  };
  const canCloseModal = () => {
    if (isLoadingFalse) {
      closeStepOneModal(false);
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        if (isLoadingFalse) {
          closeStepOneModal(false);
        }
      }}
      className="modal-dialog-centered modal-width-660 new-group-modal"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={canCloseModal}>
        <img src={crossIcon} alt="close" />
      </span>

      <ModalBody>
        {/* Header */}
        <Text size="25px" weight="500" color="#111b45">
          {t("superAdminVendorSubscription.changeSubscriptionModalHeading")}
        </Text>
        <Text
          size="16px"
          marginBottom="20px"
          marginTop="20px"
          weight="300"
          color="#535B5F"
        >
          {switchOnOff
            ? t(
                "superAdminVendorSubscription.changeSubscriptionFirstOfflineModalSubHeading"
              )
            : t(
                "superAdminVendorSubscription.changeSubscriptionFirstOnlineModalSubHeading"
              )}
          <br />
          <br />
          {t(
            "superAdminVendorSubscription.changeSubscriptionSecondModalSubHeading"
          )}
        </Text>
        <div className="background-green mt-4">
          <div
            className="d-flex gap-3 align-items-center pb-3"
            style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}
          >
            <div className="d-flex flex-column">
              <Text color="#2F3245" size="14px" weight="600">
                {t("superAdminVendorSubscription.creditCard")}
              </Text>

              <Text color="#79869A" size="13px" weight="400">
                {t("superAdminVendorSubscription.creditCardDescription")}
              </Text>
            </div>
          </div>
          <div className="d-flex gap-3 align-items-center mt-3">
            <div className="d-flex flex-column">
              <Text color="#2F3245" size="14px" weight="600">
                {t("superAdminVendorSubscription.offlinePayment")}
              </Text>

              <Text color="#79869A" size="13px" weight="400">
                {t("superAdminVendorSubscription.offlinePaymentDescription")}
              </Text>
            </div>
          </div>
        </div>

        <Text size="16px" weight="300" marginTop="20px" color="#535B5F">
          {t("superAdminVendorSubscription.modalConfirmation")}
        </Text>
        {/* Footer buttons */}
        <button
          className="button button-round button-shadow mr-sm-3 mb-3 w-sm-100 mt-4"
          title={t(
            "superAdminVendorSubscription.changeSubscriptionModalHeading"
          )}
          disabled={isLoading}
          onClick={submitRequest}
        >
          {isLoading ? (
            <div className="loader-container text-center">
              <Spinner animation="border" className="loader-spinner" />
            </div>
          ) : (
            t("confirm")
          )}
        </button>
        <button
          className="button button-round button-border btn-mobile-link button-dark mb-md-3  mt-md-4"
          onClick={canCloseModal}
          title={t("cancel")}
        >
          {t("cancel")}
        </button>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(ChangePaymentMethodModal);
